export default __webpack_public_path__ + "static/media/mister-ego.75f2d571.png";